/**
 * Metrics Overview ingredient cohorts (docs/features/metrics-overview-tab.md,
 * Requirement 5): the keys api/sql/metricsOverview.js's
 * OVERVIEW_COHORT_PREDICATES defines, each the set of Orange Book ingredients
 * behind one Overview card. A card deep-links to the FDA Sources browse view
 * with `linkFilter=cohort&cohort=<key>`.
 */

export const OVERVIEW_COHORT_KEYS = [
  'navigator',
  'notNavigator',
  'withUsdmf',
  'withNdc',
  'withBoth',
  'withNeither',
  'anySource',
  'noSource',
] as const;

export type OverviewCohortKey = (typeof OVERVIEW_COHORT_KEYS)[number];

/** Banner wording per cohort ("Viewing <label> from Orange Book"). */
export const OVERVIEW_COHORT_LABELS: Record<OverviewCohortKey, string> = {
  navigator: 'Navigator ingredients',
  notNavigator: 'ingredients not in Navigator',
  withUsdmf: 'Navigator ingredients with a USDMF',
  withNdc: 'Navigator ingredients with an NDC registration',
  withBoth: 'Navigator ingredients with both a USDMF and an NDC registration',
  withNeither: 'Navigator ingredients with no USDMF or NDC registration',
  anySource: 'ingredients with any source (Navigator, NDC or USDMF)',
  noSource: 'ingredients with no source at all',
};

export function isOverviewCohortKey(
  value: string | null
): value is OverviewCohortKey {
  return (
    value !== null &&
    (OVERVIEW_COHORT_KEYS as readonly string[]).includes(value)
  );
}
